import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var integralRoute = [{
  path: "integral",
  name: "integral",
  component: function component() {
    return import("./integral.vue");
  }
}];